import { generateActions } from "../generateActions";
import { eDanhSachLopTinChiActionsObj } from './../../action-types/lop-tin-chi/IDanhSachLopTinChiActions';

export const danhSachLopTinChiActions = {
  ...generateActions(eDanhSachLopTinChiActionsObj, "DANH_SACH_LOP_TC"),

};
